import { render } from "./CreateHandStat.vue?vue&type=template&id=71756aa4"
import script from "./CreateHandStat.vue?vue&type=script&lang=js"
export * from "./CreateHandStat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__